const defaultTrialEntryUrl = "https://app.inflowmax.com";
const defaultLoginEntryUrl = "https://app.inflowmax.com/login";

export const trialEntryUrl = import.meta.env.VITE_TRIAL_ENTRY_URL || defaultTrialEntryUrl;
export const loginEntryUrl = import.meta.env.VITE_LOGIN_ENTRY_URL || defaultLoginEntryUrl;
